import { z } from "zod";

export const UserSocialSettingsSchema = z.object({
  userId: z.string(),
  isPrivate: z.boolean(),
  allowDirectMessages: z.boolean(),
  updatedAt: z.union([z.string(), z.date()]).optional(),
});
export type UserSocialSettings = z.infer<typeof UserSocialSettingsSchema>;

export const ConnectionStatusSchema = z.enum([
  "pending",
  "accepted",
  "blocked",
]);
export type ConnectionStatus = z.infer<typeof ConnectionStatusSchema>;

export const UserConnectionSchema = z.object({
  id: z.string().uuid(),
  requesterId: z.string(),
  addresseeId: z.string(),
  status: ConnectionStatusSchema,
  createdAt: z.union([z.string(), z.date()]).optional(),
  updatedAt: z.union([z.string(), z.date()]).optional(),
});
export type UserConnection = z.infer<typeof UserConnectionSchema>;

export const PostSchema = z.object({
  id: z.string().uuid(),
  userId: z.string(),
  content: z.string().nullable().optional(),
  routeAscentId: z.string().uuid().nullable().optional(),
  routeId: z.string().uuid().nullable().optional(),
  modelId: z.string().uuid().nullable().optional(),
  areaId: z.string().uuid().nullable().optional(),
  createdAt: z.union([z.string(), z.date()]).optional(),
  updatedAt: z.union([z.string(), z.date()]).optional(),
});
export type Post = z.infer<typeof PostSchema>;

export const MediaTypeSchema = z.enum(["image", "video"]);
export type MediaType = z.infer<typeof MediaTypeSchema>;

export const PostMediaSchema = z.object({
  id: z.string().uuid(),
  postId: z.string().uuid(),
  mediaUrl: z.string(),
  mediaType: MediaTypeSchema,
  metadata: z.any().optional(),
  sortOrder: z.number(),
  createdAt: z.union([z.string(), z.date()]).optional(),
});
export type PostMedia = z.infer<typeof PostMediaSchema>;

export const PostCommentSchema = z.object({
  id: z.string().uuid(),
  postId: z.string().uuid(),
  userId: z.string(),
  content: z.string(),
  createdAt: z.union([z.string(), z.date()]).optional(),
  updatedAt: z.union([z.string(), z.date()]).optional(),
});
export type PostComment = z.infer<typeof PostCommentSchema>;

export const ReactionTypeSchema = z.enum(["like", "stoke", "fire", "beta"]);
export type ReactionType = z.infer<typeof ReactionTypeSchema>;

export const PostReactionSchema = z.object({
  id: z.string().uuid(),
  postId: z.string().uuid(),
  userId: z.string(),
  reactionType: ReactionTypeSchema,
  createdAt: z.union([z.string(), z.date()]).optional(),
});
export type PostReaction = z.infer<typeof PostReactionSchema>;

export const NotificationTypeSchema = z.enum([
  "friend_request",
  "friend_accepted",
  "post_like",
  "post_comment",
  "post_mention",
]);
export type NotificationType = z.infer<typeof NotificationTypeSchema>;

export const NotificationSchema = z.object({
  id: z.string().uuid(),
  recipientId: z.string(),
  actorId: z.string(),
  type: NotificationTypeSchema,
  referenceId: z.string().uuid().nullable().optional(),
  readAt: z.union([z.string(), z.date()]).nullable().optional(),
  createdAt: z.union([z.string(), z.date()]).optional(),
});
export type Notification = z.infer<typeof NotificationSchema>;
